const normalizeCartItems = (items) => {
    if (!items) return []
    if (Array.isArray(items)) return items.filter(Boolean)
    if (typeof items === 'object') return Object.values(items).filter(Boolean)
    return []
}

const getCalculatorData = (item = {}) => {
    return item?.calculatorData && typeof item.calculatorData === 'object'
        ? item.calculatorData
        : {}
}

export const isCartItemConfirmationRequired = (item = {}) => {
    const calc = getCalculatorData(item)

    if (item?.confirmationRequired === false || calc?.confirmationRequired === false) {
        return false
    }

    if (item?.confirmationRequired === true || calc?.confirmationRequired === true) {
        return true
    }

    // Совместимость со старыми configured-позициями 3D-калькулятора:
    // itemConfirmed уже было, а confirmationRequired ещё не записывалось.
    const isLegacyConfigured = item?.calculatorConfigured === true || calc?.configured === true

    if (!isLegacyConfigured) return false

    return Object.prototype.hasOwnProperty.call(item || {}, 'itemConfirmed') ||
        Object.prototype.hasOwnProperty.call(calc || {}, 'itemConfirmed')
}

export const isCartItemConfirmed = (item = {}) => {
    if (!isCartItemConfirmationRequired(item)) return true

    const calc = getCalculatorData(item)

    return item?.itemConfirmed === true || calc?.itemConfirmed === true
}

export const getCartItemConfirmationState = (item = {}) => {
    const required = isCartItemConfirmationRequired(item)
    const confirmed = isCartItemConfirmed(item)

    if (!required) {
        return {
            required: false,
            confirmed: true,
            status: 'not_required',
            label: 'Подтверждение не требуется',
        }
    }

    if (confirmed) {
        return {
            required: true,
            confirmed: true,
            status: 'confirmed',
            label: 'Подтверждено',
        }
    }

    return {
        required: true,
        confirmed: false,
        status: 'pending',
        label: 'Нужно подтвердить в 3D',
    }
}

export const getCartConfirmationSummary = (items) => {
    const normalized = normalizeCartItems(items)
    const requiredItems = normalized.filter(isCartItemConfirmationRequired)
    const confirmedItems = requiredItems.filter(isCartItemConfirmed)
    const pendingItems = requiredItems.filter((item) => !isCartItemConfirmed(item))

    return {
        totalCount: normalized.length,
        requiredCount: requiredItems.length,
        confirmedCount: confirmedItems.length,
        pendingCount: pendingItems.length,
        pendingItems,
        allConfirmed: pendingItems.length === 0,
    }
}
